nonHostChars